import { render } from "./wednesday.vue?vue&type=template&id=cfa90d4a"
import script from "./wednesday.vue?vue&type=script&lang=js"
export * from "./wednesday.vue?vue&type=script&lang=js"

import "./wednesday.vue?vue&type=style&index=0&id=cfa90d4a&lang=scss"
script.render = render

export default script